import { FC } from 'react';

import { nullNoop } from 'utils/noop';

import { IBonusPointsProps } from './types';

export default nullNoop as FC<IBonusPointsProps>;
